import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
const constants = {
  flinks: [
    {
      title: "Blog",
      link: "/blogs",
    },
    {
      title: "Faq",
      link: "/faqs",
    },
    {
      title: "Support",
      link: "#",
    },
  ],

  fcompany: [
    {
      title: "About Us",
      link: "/about-us",
    },
    {
      title: "Contact Us",
      link: "/contact-us",
    },
    {
      title: "Services",
      link: "/services",
    },
    {
      title: "Opportunities",
      link: "#",
    },
  ],

  flegal: [
    { title: "Terms & Conditions", link: "/terms-and-condition" },
    { title: "Privacy Policy", link: "/privacy-policy" },
    { title: "Cookies", link: "#" },
  ],

  social: [
    {
      icon: FaFacebook,
      name: "Facebook",
      link: "#",
    },
    {
      icon: FaInstagram,
      name: "Instagram",
      link: "#",
    },
    {
      icon: FaTwitter,
      name: "Twitter",
      link: "#",
    },
  ],
};

export default constants;
